function copyText(text, element) {
  navigator.clipboard.writeText(element.href ?? text).then(() => {
    showPopover(element, 'Copied!');
  }).catch(err => {
    showPopover(element, 'Failed to copy');
  });
}

function showPopover(target, message) {
  let popover = document.createElement('div');
  popover.className = 'popover';
  popover.innerText = message;
  document.body.appendChild(popover);

  // Position the popover
  const rect = target.getBoundingClientRect();
  const scrollY = window.scrollY || document.documentElement.scrollTop; // Get vertical scroll position

  popover.style.left = `${rect.left}px`;
  popover.style.top = `${rect.bottom + scrollY + 5}px`; // Add scroll position to top calculation
  popover.style.display = 'block';
  popover.style.position = 'absolute'; // Ensure the positioning is absolute with respect to the document

  // Automatically hide after 2 seconds
  setTimeout(() => {
    popover.remove();
  }, 2000);
}

export const initCopy = () => {
  document.querySelectorAll('.copy-link').forEach(element => {
    element.addEventListener('click', event => {
      event.preventDefault();
      copyText(element.innerText, element);
    });
  });
};
